import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Table from 'react-bootstrap/Table';
import { getFirestore } from "@firebase/firestore";
import { app } from '../firebase.js';
import { collection, doc, orderBy, setDoc,query, getDocs, deleteDoc, where, updateDoc} from "@firebase/firestore"; 
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import swal from 'sweetalert';
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import defaulProfPic from '../Images/defprofile.png'
import MaskedPhone from '../Components/MaskedPhone';
import { logAdminActivity } from '../utils/activityLogger';

function ActiveStudentsComp() {
    const db = getFirestore(app);
    const auth = getAuth();
    let navigate = useNavigate();
  
  const [studentsList, setStudentList] = useState([]);
  const [countAllData, setcountAllData ] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCourse, setFilterCourse] = useState('All');
  const [filterCountry, setFilterCountry] = useState('All');
  const lastSearchRef = useRef('');
  const lastCourseRef = useRef(filterCourse);
  const lastCountryRef = useRef(filterCountry);
  
  useEffect(() => {
    const fetchData = async () => {
          const q = query(collection(db, 'users'), orderBy("appDate", 'desc'), where("userStatus", "==", "Student"));
          const querySnapshot = await getDocs(q);
          const studentsItem = [];
          querySnapshot.forEach((doc) => {
              studentsItem.push({ id: doc.id, ...doc.data() });
          });
          setStudentList(studentsItem);
          setcountAllData(studentsItem.length)
  
      };
  
      fetchData();
    }, []);

  useEffect(() => {
    const trimmed = searchTerm.trim();
    const timeoutId = setTimeout(() => {
      if (trimmed === lastSearchRef.current) return;
      lastSearchRef.current = trimmed;
      if (trimmed) {
        logAdminActivity({
          action: 'Search',
          details: `Active Students search: "${trimmed}"`,
          meta: { page: 'Active Students', query: trimmed }
        });
      }
    }, 600);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  useEffect(() => {
    if (filterCourse === lastCourseRef.current) return;
    lastCourseRef.current = filterCourse;
    logAdminActivity({
      action: 'Filter',
      details: `Active Students course filter: ${filterCourse}`,
      meta: { page: 'Active Students', filter: 'course', value: filterCourse }
    });
  }, [filterCourse]);

  useEffect(() => {
    if (filterCountry === lastCountryRef.current) return;
    lastCountryRef.current = filterCountry;
    logAdminActivity({
      action: 'Filter',
      details: `Active Students country filter: ${filterCountry}`,
      meta: { page: 'Active Students', filter: 'country', value: filterCountry }
    });
  }, [filterCountry]);
  
  
  function viewStudent(userId, studentName) {
    logAdminActivity({
      action: 'View Student',
      details: `Opened student profile: ${studentName || 'student'}`,
      meta: { page: 'Active Students', studentId: userId, studentName: studentName || '' }
    });
    navigate('/view-student', { state: { myData: userId } });
  }

  const uniqueCourses = Array.from(new Set(studentsList.map((student) => student.course).filter(Boolean))).sort();
  const uniqueCountries = Array.from(new Set(studentsList.map((student) => student.nationality).filter(Boolean))).sort();
  const filteredStudents = studentsList.filter((student) => {
    const search = searchTerm.trim().toLowerCase();
    const matchesSearch = !search || [
      student.bio,
      student.course,
      student.nationality,
      student.phoneNumber
    ].some((value) => String(value || '').toLowerCase().includes(search));

    const matchesCourse = filterCourse === 'All' || student.course === filterCourse;
    const matchesCountry = filterCountry === 'All' || student.nationality === filterCountry;
    return matchesSearch && matchesCourse && matchesCountry;
  });

  const formatDateTime = (value) => {
    if (!value) return '—';
    const dateObj = value.toDate ? value.toDate() : new Date(value);
    if (Number.isNaN(dateObj.getTime())) return '—';
    const datePart = dateObj.toLocaleDateString();
    const timePart = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return `${datePart} • ${timePart}`;
  };

  const totalCount = countAllData;
  const filteredCount = filteredStudents.length;

    return (
      <div className="clientsComp applicationsPage">
        <div className="appsHeader">
          <div>
            <p className="appsKicker">Students</p>
            <h4>Active Students</h4>
            <p className="appsSubtext">Currently enrolled students across all courses.</p>
          </div>
          <div className="appsHeaderStats">
            <div className="appsStatChip">
              <span>All</span>
              <strong>{totalCount}</strong>
            </div>
            <div className="appsStatChip">
              <span>Showing</span>
              <strong>{filteredCount}</strong>
            </div>
          </div>
        </div>

        <div className="appsFiltersCard">
          <div className="appsSearch input-group">
            <span className="input-group-text"><FontAwesomeIcon icon={faSearch} /></span>
            <Form.Control
              type="text"
              placeholder="Search name, course, phone..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="appsFilterGroup">
            <Form.Select className="filterSelect" value={filterCourse} onChange={(e) => setFilterCourse(e.target.value)}>
              <option value="All">All Courses</option>
              {uniqueCourses.map((course) => (
                <option key={course} value={course}>{course}</option>
              ))}
            </Form.Select>
            <Form.Select className="filterSelect" value={filterCountry} onChange={(e) => setFilterCountry(e.target.value)}>
              <option value="All">All Countries</option>
              {uniqueCountries.map((country) => (
                <option key={country} value={country}>{country}</option>
              ))}
            </Form.Select>
          </div>
        </div>

        <div className="appsTableCard">
          <div className="appsTableHeader">
            <h6>Active Students</h6>
            <span>{filteredCount} results</span>
          </div>
          <div className="appsTableWrap">
            <Table hover responsive className="appsTable">
              <thead>
                <tr>
                  <th>Student</th>
                  <th>Application Date</th>
                  <th>Course</th>
                  <th>Country</th>
                  <th>Phone</th>
                  <th>Cohort</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filteredStudents.map((mystudent) => (
                  <tr key={mystudent.id}>
                    <td>
                      <div className="appsStudentCell">
                        <div className='appDefProfPic'>
                          <img src={mystudent.profilePic ? mystudent.profilePic : defaulProfPic} alt="profile" />
                        </div>
                        <div>
                          <p className="appsStudentName">{mystudent.bio || 'Unnamed student'}</p>
                          <span className="appsStudentMeta">{mystudent.course || 'Course not set'}</span>
                        </div>
                      </div>
                    </td>
                    <td>{formatDateTime(mystudent.appDate)}</td>
                    <td>{mystudent.course || '—'}</td>
                    <td>{mystudent.nationality || '—'}</td>
                    <td>
                      <MaskedPhone
                        phoneNumber={mystudent.phoneNumber}
                        studentId={mystudent.userId}
                        studentName={mystudent.bio}
                      />
                    </td>
                    <td>{mystudent.cohort || '—'}</td>
                    <td>
                      <button className='appsViewBtn' onClick={() => viewStudent(mystudent.userId, mystudent.bio)}>
                        View
                      </button>
                    </td>
                  </tr>
                ))}
                {filteredStudents.length === 0 && (
                  <tr>
                    <td colSpan="7" className="appsEmptyState">
                      No active students match your filters yet.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
  
    )
  }
  

export default ActiveStudentsComp
